import { render, staticRenderFns } from "./Allfeedback.vue?vue&type=template&id=9995f6d4&scoped=true&"
import script from "./Allfeedback.vue?vue&type=script&lang=js&"
export * from "./Allfeedback.vue?vue&type=script&lang=js&"
import style0 from "./Allfeedback.vue?vue&type=style&index=0&id=9995f6d4&prod&lang=scss&"
import style1 from "./Allfeedback.vue?vue&type=style&index=1&id=9995f6d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9995f6d4",
  null
  
)

export default component.exports